import React from 'react';
import {
  FiGlobe, FiUsers, FiTarget, FiHeart, FiShield, FiZap, FiMail,
} from 'react-icons/fi';
import SEO from '../components/SEO/SEO';

const About: React.FC = () => {
  const features = [
    {
      icon: <FiGlobe className="w-8 h-8 text-blue-500" />,
      title: 'Global Coverage',
      description: 'Comprehensive travel information for countries worldwide, helping travelers make informed decisions.',
    },
    {
      icon: <FiShield className="w-8 h-8 text-green-500" />,
      title: 'Verified Information',
      description: 'All information is sourced from official government websites and verified sources.',
    },
    {
      icon: <FiZap className="w-8 h-8 text-yellow-500" />,
      title: 'Fast & Reliable',
      description: 'Quick access to travel requirements and visa information when you need it most.',
    },
    {
      icon: <FiUsers className="w-8 h-8 text-purple-500" />,
      title: 'Community Driven',
      description: 'Built by travelers, for travelers. We understand the challenges of international travel.',
    },
  ];

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About travelbaba786',
    url: 'https://travelbaba786.com/about',
    description: 'travelbaba786 is your trusted gateway to official e-visas, ETA, and online entry application portals for every country in the world. We provide verified links to government websites.',
    mainEntity: {
      '@type': 'Organization',
      name: 'travelbaba786',
      url: 'https://travelbaba786.com',
      description: 'An independent directory providing verified links to official government websites for visa applications and travel documentation.',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'liaqatapril@gmail.com',
        contactType: 'Customer Service',
      },
    },
  };

  return (
    <>
      <SEO
        title="About travelbaba786 - Verified Directory for Official Government Visa Portals"
        description="travelbaba786 is your trusted gateway to official e-visas, ETA, and online entry application portals for every country in the world. We provide verified links to government websites to help travelers avoid scams and overpriced services."
        keywords="about travelers api, verified visa directory, official government portals, e-visa directory, travel information directory, visa application help"
        url="https://travelbaba786.com/about"
        type="article"
        structuredData={structuredData}
      />
      <div className="max-w-7xl mx-auto">
        {/* Hero Section */}
      <div className="text-center mb-20">
        <div className="mb-8 group">
          <div className="relative inline-block">
            <div
              className="absolute inset-0 rounded-full blur-2xl scale-150 bg-red-500/20 dark:bg-red-600/20"
            ></div>
            <div
              className="relative w-24 h-24 rounded-full flex items-center justify-center border-2 bg-white/50 dark:bg-gray-800 border-red-300/30 dark:border-red-500 group-hover:scale-110 transition-transform duration-500"
            >
              <FiHeart className="w-12 h-12 text-red-500 dark:text-red-400" />
            </div>
          </div>
        </div>
        <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gray-900 via-red-600 to-red-700 bg-clip-text text-transparent dark:text-white">
          About travelbaba786
        </h1>

        {/* Tagline */}
        <p className="text-2xl font-semibold mb-6 text-gray-700 dark:text-gray-200">
          travelbaba786 – Your Trusted Gateway to Official E-Visas
        </p>

        <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed text-gray-600 dark:text-gray-300">
          At travelbaba786, our mission is simple yet vital: to provide a single, reliable
          source for the official government e-visa, ETA, and online entry application portals
          for every country in the world.
        </p>
      </div>

      {/* Problem Section */}
   <div
    className="text-center p-10 rounded-3xl mb-20 shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700"
>
  <h2
  className="text-[32px] font-bold mb-6 text-gray-800 dark:text-white"
  >
    The Problem
  </h2>

  <p
  className="text-[16px] leading-relaxed max-w-4xl mx-auto text-gray-700 dark:text-gray-300"
  >
    When you search for "e-visa for [Country]," the top results are often cleverly
    disguised commercial sites. They look official but aren't — they overcharge you,
    and worse, they might misuse your passport and payment details.
  </p>
</div>

      {/* Our Solution Section */}
     

<div
    className="text-center p-10 rounded-3xl mb-20 shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700"
>
  <div className="mb-6">
    <div
  className="w-16 h-16 rounded-full flex items-center justify-center border-2 mx-auto bg-white dark:bg-gray-800 border-blue-200 dark:border-blue-500"
    >
      <FiTarget className="w-8 h-8 text-blue-500 dark:text-blue-400" />
    </div>
  </div>

  <h2
  className="text-[32px] font-bold mb-6 text-gray-800 dark:text-white"
  >
    Our Solution – The Verified Directory
  </h2>

  <p
    className="text-[16px] max-w-4xl mx-auto leading-relaxed text-gray-700 dark:text-gray-300"
  >
    We are the antidote to the confusion. Think of us as the "verified checkmark"
    for government visa portals. We have done the hard work for you — providing
    verified links to official government e-visa, ETA, and entry application
    portals for every country in the world.
  </p>
</div>

      {/* Clarification of Role Section */}
      <div
        className="text-center p-10 rounded-3xl mb-20 shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700"
      >
        <h2
          className="text-[32px] font-bold mb-6 text-gray-800 dark:text-white"
        >
          What We Do
        </h2>
        <p className="text-[16px] leading-relaxed max-w-4xl mx-auto text-gray-700 dark:text-gray-300">
          We are not a government agency and do not process visa applications. We are an independent directory that provides links to official government websites for your convenience and safety.
        </p>
      </div>

      {/* Why Choose Us Section */}
      <div className="mb-20">
        <div className="text-center mb-12">
          <h2 className="text-[32px] font-bold mb-4 text-gray-800 dark:text-white">
            Why Choose travelbaba786?
          </h2>
          <p className="text-[16px] text-gray-700 dark:text-gray-300">
            Discover what makes us the trusted choice for travelers worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group rounded-3xl p-8 text-center transition-all duration-500 transform hover:-translate-y-1 shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600"
            >
              <div className="flex justify-center mb-6 group-hover:scale-110 transition-transform duration-500">
                <div className="p-4 rounded-xl bg-gray-100 dark:bg-gray-800">
                  {feature.icon}
                </div>
              </div>
              <h3 className="text-[18px] font-semibold mb-3 text-gray-800 dark:text-white">
                {feature.title}
              </h3>
              <p className="text-[15px] leading-relaxed text-gray-600 dark:text-gray-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
      {/* Community Engagement Section */}
      <div
        className="text-center p-10 rounded-3xl mb-20 shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700"
      >
        <h2
          className="text-[32px] font-bold mb-6 text-gray-800 dark:text-white"
        >
          Join Our Community
        </h2>
        <p
          className="text-[16px] leading-relaxed mb-6 text-gray-600 dark:text-gray-300"
        >
          Found this useful? Bookmark our site and share it with fellow travelers to help us build a safer travel community.
        </p>
      </div>

      {/* Contact & Error Reporting Section */}
      <div
        className="text-center p-10 rounded-3xl mb-20 shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700"
      >
        <h2
          className="text-[32px] font-bold mb-6 text-gray-800 dark:text-white"
        >
          Help Us Stay Accurate
        </h2>
        <p
          className="text-[16px] leading-relaxed mb-6 text-gray-600 dark:text-gray-300"
        >
          If you find a link that isn't working or seems incorrect, please contact us immediately.
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 text-[15px] text-gray-700 dark:text-gray-300">
          <div className="flex items-center gap-2">
            <FiMail className="w-6 h-6 text-blue-400" />
            <a href="mailto:liaqatapril@gmail.com" className="text-blue-600 dark:text-blue-400 font-semibold">
              liaqatapril@gmail.com
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer Section */}
      <div
        className="text-center p-10 rounded-3xl mb-20 shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700"
      >
        <h2
          className="text-[32px] font-bold mb-6 text-gray-800 dark:text-white"
        >
          Disclaimer
        </h2>
        <p className="text-[16px] leading-relaxed mb-6 text-gray-600 dark:text-gray-300 max-w-4xl mx-auto">
          We are not a government agency and do not process visa applications. We are an independent directory that provides links to official government websites for your convenience and safety.
        </p>
      </div>

      {/* Business Enquiries Section */}
      <div
        className="text-center p-10 rounded-3xl mb-20 shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700"
      >
        <h3 className="text-[20px] font-semibold mb-4 text-gray-800 dark:text-white">
          Contact us for business enquiries
        </h3>
        <div className="flex justify-center">
          <div className="flex items-center gap-2">
            <FiMail className="w-6 h-6 text-blue-400" />
            <a
              href="mailto:liaqatapril@gmail.com"
              className="text-[16px] text-blue-600 dark:text-blue-400 font-semibold"
            >
              liaqatapril@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default About;


 